import styled from 'react-emotion';

export const Wrapper = styled('div')`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  @media screen and (min-width: 96em) {
    flex: 0 0 90%;
  }
`;

export const FormElement = styled('form')`
  width: 100%;
  height: 100%;
`;



// WEBPACK FOOTER //
// ../shop_main/components/formwizard/style.js